import { Injectable } from "@angular/core";
import { timer } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class Step3Service {


    async load(type: string): Promise<Array<string>> {
        return timer(0).pipe(
            map(()=>{
                if (type?.startsWith('A')) {
                    return ['A11','A21',"A23"];
                } else if (type?.startsWith('B')) {
                    return ['B12','B22','B32']
                }
                return []
            })
        ).toPromise()
    } 
}